const FANDUEL_CASINO_HOST_RE = /^(.*\.)?fanduel\.(com|ca)$/i;

export const normalizeRafDestinationUrl = (destinationURL: string): string | null => {
    if (!destinationURL) return null;
    if (destinationURL.startsWith('/')) return destinationURL;

    try {
        const parsed = new URL(destinationURL);
        if (FANDUEL_CASINO_HOST_RE.test(parsed.host)) {
            return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
        return destinationURL;
    } catch {
        return null;
    }
};
